import { render } from "./form-edit-organization.vue?vue&type=template&id=c0e3beec"
import script from "./form-edit-organization.vue?vue&type=script&lang=js"
export * from "./form-edit-organization.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__